import { jsx as _jsx } from "react/jsx-runtime";
import { MapTo } from "@adobe/aem-react-editable-components";
import classNames from "classnames";
import ImageV2 from "@jti/aem-core-components-react-base/dist/authoring/image/v2/ImageV2";
import { withEditConfig } from "../../../app-related/withAemAuthoring";
import style from "./Image.module.scss";
const ImageEditConfig = {
    emptyLabel: "Image",
    isEmpty: (props) => !props.src,
};
export const CoreImage = (props) => {
    const newProps = {
        ...props,
        routed: false,
    };
    const classes = classNames(style.coreImage, {
        [style.fullWidth]: props.isFullWidth,
    });
    if (ImageEditConfig.isEmpty(props))
        return null;
    return (_jsx("div", { className: classes, id: props.id, children: _jsx(ImageV2, { ...newProps }) }));
};
export default MapTo("loyalty/components/core/image")(withEditConfig(CoreImage, ImageEditConfig));
